var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.75C19 6.35218 19 5.40326 18.7716 4.85195C18.4672 4.11687 17.8831 3.53284 17.1481 3.22836C16.5967 3 15.8978 3 14.5 3C13.4714 3 12.4428 3 11.4142 3C11.2456 3 11.1613 3 11.0801 2.99559C10.3976 2.95855 9.7482 2.68957 9.2394 2.23317C9.1788 2.17884 9.1192 2.11923 9 2C8.88077 1.88077 8.82116 1.82116 8.7606 1.76683C8.25181 1.31043 7.60243 1.04145 6.91994 1.00441C6.83871 1 6.7544 1 6.58579 1C6.32386 1 6.06193 1 5.8 1C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8C1 7.93333 1 10.0667 1 12.2C1 13.8802 1 14.7202 1.32698 15.362C1.6146 15.9265 2.07354 16.3854 2.63803 16.673C3.27976 17 4.11984 17 5.8 17C7.2 17 8.6 17 10 17",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34065 9C5.34065 9 2.70346 11.3649 2.32954 12.8829C1.95562 14.4009 2.00256 14.9553 2.32954 15.5309C2.61716 16.0372 3.0761 16.4488 3.64059 16.7067C4.28232 17 5.1224 17 6.80256 17C9.60256 17 12.4026 17 15.2026 17C16.8828 17 17.0818 17 17.7236 16.7067C18.2881 16.4488 18.747 16.0372 19.0346 15.5309C19.2036 15.2334 19.3787 14.2957 19.9525 12.8829C20.4887 11.5627 21.4091 9.78141 22.0026 9H5.34065Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOutline);
export default __webpack_public_path__ + "static/media/folderOutline.a40c5e0c9b4be7cf67011bf29d0ca785.svg";
export { ForwardRef as ReactComponent };